const ANCHOR_OPEN_TAG_REGEX = /<a\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gi;
const ATTR_REGEX = /\s+([^\s"'>/=]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+)))?/g;
const IDEA_PATH_REGEX = /^\/idea\/[^/?#\s]+/i;
const BAGEL_HOST_REGEX = /^(?:[\w-]+\.)*bagel\.ai$/i;

function isIdeaPageHref(href: string): boolean {
  const trimmed = href.trim();
  if (IDEA_PATH_REGEX.test(trimmed)) {
    return true;
  }
  const absolute = trimmed.match(/^https?:\/\/([^/?#]+)(\/.*)?$/i);
  if (!absolute) {
    return false;
  }
  const [, authority, path = ''] = absolute;
  if (!IDEA_PATH_REGEX.test(path)) {
    return false;
  }
  const host = authority.replace(/:\d+$/, '');
  const currentHost = typeof window === 'undefined' ? '' : window.location.host;
  return BAGEL_HOST_REGEX.test(host) || host === 'localhost' || authority === currentHost;
}

/**
 * Makes links to a Bagel Idea page inside rendered answer HTML open in a new tab (same as the
 * "Open idea page" hover action). Every other anchor, and all other markup, is left untouched.
 */
export function openIdeaLinksInNewTab(html: string): string {
  return html.replace(ANCHOR_OPEN_TAG_REGEX, (tag, attrs: string) => {
    const parsed = Array.from(attrs.matchAll(ATTR_REGEX));
    const hrefAttr = parsed.find(([, name]) => name.toLowerCase() === 'href');
    const href = hrefAttr?.[2] ?? hrefAttr?.[3] ?? hrefAttr?.[4];
    if (href === undefined || !isIdeaPageHref(href)) {
      return tag;
    }
    const kept = parsed
      .filter(([, name]) => !['target', 'rel'].includes(name.toLowerCase()))
      .map(([raw]) => raw)
      .join('');
    return `<a${kept} target="_blank" rel="noopener noreferrer">`;
  });
}
